let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("59Z93")).then(() => parcelRequire('fY7GX'));